import { createReducer, on } from '@ngrx/store';

import { RefrigerationCircuitMessagesActions } from './refrigeration-circuit-messages.actions';
import { RefrigerationCircuitMessagesState } from './refrigeration-circuit-messages.state';

export const initRefrigerationCircuitMessagesState: RefrigerationCircuitMessagesState = {
  messages: null,
  loading: false,
  loaded: false,
  error: null,
};

export const refrigerationCircuitMessagesReducer = createReducer(
  initRefrigerationCircuitMessagesState,

  on(
    RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessages,
    (state): RefrigerationCircuitMessagesState => ({
      ...state,
      loading: true,
      loaded: false,
    })
  ),

  on(
    RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessagesSuccess,
    (state, { messages }): RefrigerationCircuitMessagesState => ({
      ...state,
      messages,
      loading: false,
      loaded: true,
    })
  ),

  on(
    RefrigerationCircuitMessagesActions.getRefrigerationCircuitMessagesError,
    (state, { error }): RefrigerationCircuitMessagesState => ({
      ...state,
      loading: false,
      loaded: true,
      error,
    })
  )
);
